import React, { useEffect, useState } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

const TIPO_LABEL:Record<string,string> = {
  manutencao_alerta: "🔧 Manutenção",
  relatorio_agendado: "📊 Relatório",
  senha_usuario: "🔑 Senha",
  alerta_docs: "📄 Documentos",
}

const fmtData = (d:any) => d ? new Date(d).toLocaleString("pt-BR") : "—"

export default function EmailLogs() {
  const [logs, setLogs]           = useState<any[]>([])
  const [loading, setLoading]     = useState(true)
  const [filtroTipo, setFiltroTipo] = useState("")
  const [filtroStatus, setFiltroStatus] = useState("")
  const [busca, setBusca]         = useState("")
  const [pagina, setPagina]       = useState(1)
  const POR_PAGINA = 20

  const reenviar = async (id:string) => {
    try {
      const r = await axios.post(`${API}/email-logs/${id}/reenviar`)
      alert(r.data.mensagem)
      carregar()
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao reenviar") }
  }

  const carregar = async () => {
    try {
      const r = await axios.get(`${API}/email-logs`)
      setLogs(r.data)
    } catch {} finally { setLoading(false) }
  }

  useEffect(()=>{ carregar() },[])

  const filtrados = logs.filter(l => {
    if (filtroTipo && l.tipo !== filtroTipo) return false
    if (filtroStatus && l.status !== filtroStatus) return false
    if (busca && !l.destinatario?.toLowerCase().includes(busca.toLowerCase()) &&
        !l.assunto?.toLowerCase().includes(busca.toLowerCase())) return false
    return true
  })

  const paginados = filtrados.slice((pagina-1)*POR_PAGINA, pagina*POR_PAGINA)
  const totalPaginas = Math.ceil(filtrados.length/POR_PAGINA)

  const totalEnviados = logs.filter(l=>l.status==="enviado").length
  const totalErros    = logs.filter(l=>l.status==="erro").length
  const tipos = logs.map(l=>l.tipo).filter((t,i,a)=>a.indexOf(t)===i)

  return (
    <div style={{padding:24,height:"100%",overflowY:"auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:700}}>📧 Histórico de E-mails</h2>
          <p style={{fontSize:13,color:"#64748b"}}>{filtrados.length} registro(s)</p>
        </div>
        <button className="btn btn-ghost" onClick={carregar}>🔄 Atualizar</button>
      </div>

      {/* Cards resumo */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:16,marginBottom:20}}>
        {[
          {label:"Total enviados", valor:totalEnviados, cor:"#22c55e", icone:"✅"},
          {label:"Total erros",    valor:totalErros,    cor:"#f87171", icone:"❌"},
          {label:"Total registros",valor:logs.length,   cor:"#0ea5e9", icone:"📧"},
          {label:"Últimas 24h",    valor:logs.filter(l=>new Date(l.criado_em)>new Date(Date.now()-86400000)).length, cor:"#f59e0b", icone:"🕐"},
        ].map((s,i)=>(
          <div key={i} className="card" style={{padding:"14px 16px"}}>
            <div style={{fontSize:22,marginBottom:6}}>{s.icone}</div>
            <div style={{fontSize:20,fontWeight:700,color:s.cor}}>{s.valor}</div>
            <div style={{fontSize:11,color:"#64748b"}}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Filtros */}
      <div style={{display:"flex",gap:12,marginBottom:16}}>
        <input placeholder="Buscar destinatário ou assunto..." value={busca}
          onChange={e=>{setBusca(e.target.value);setPagina(1)}}
          style={{flex:1,maxWidth:300}} />
        <select value={filtroTipo} onChange={e=>{setFiltroTipo(e.target.value);setPagina(1)}} style={{minWidth:160}}>
          <option value="">Todos os tipos</option>
          {tipos.map(t=><option key={t} value={t}>{TIPO_LABEL[t]||t}</option>)}
        </select>
        <select value={filtroStatus} onChange={e=>{setFiltroStatus(e.target.value);setPagina(1)}} style={{minWidth:130}}>
          <option value="">Todos status</option>
          <option value="enviado">✅ Enviado</option>
          <option value="erro">❌ Erro</option>
        </select>
      </div>

      {/* Tabela */}
      <div className="card" style={{padding:0,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{background:"#0d1b2e"}}>
              {["Data/Hora","Tipo","Destinatário","Assunto","Status","Erro",""].map(h=>(
                <th key={h} style={{padding:"10px 14px",textAlign:"left",fontSize:11,
                  color:"#64748b",fontWeight:600,textTransform:"uppercase"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} style={{padding:24,textAlign:"center",color:"#64748b"}}>Carregando...</td></tr>
            ) : paginados.length===0 ? (
              <tr><td colSpan={6} style={{padding:24,textAlign:"center",color:"#64748b"}}>Nenhum registro encontrado</td></tr>
            ) : paginados.map((l:any)=>(
              <tr key={l.id} style={{borderBottom:"1px solid rgba(45,65,102,0.4)"}}>
                <td style={{padding:"10px 14px",fontSize:11,color:"#94a3b8",whiteSpace:"nowrap"}}>{fmtData(l.criado_em)}</td>
                <td style={{padding:"10px 14px",fontSize:11}}>{TIPO_LABEL[l.tipo]||l.tipo}</td>
                <td style={{padding:"10px 14px",fontSize:11,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}
                  title={l.destinatario}>{l.destinatario}</td>
                <td style={{padding:"10px 14px",fontSize:11,maxWidth:250,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}
                  title={l.assunto}>{l.assunto||"—"}</td>
                <td style={{padding:"10px 14px"}}>
                  <span style={{fontSize:10,padding:"2px 8px",borderRadius:10,
                    background:l.status==="enviado"?"#14532d":"#450a0a",
                    color:l.status==="enviado"?"#4ade80":"#f87171"}}>
                    {l.status==="enviado"?"✅ Enviado":"❌ Erro"}
                  </span>
                </td>
                <td style={{padding:"10px 14px",fontSize:10,color:"#f87171",maxWidth:200,
                  overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}
                  title={l.erro_msg}>{l.erro_msg||"—"}</td>
                <td style={{padding:"10px 14px"}}>
                  <button className="btn btn-ghost" style={{padding:"3px 8px",fontSize:10}}
                    title="Reenviar email" onClick={()=>reenviar(l.id)}>
                    🔄 Reenviar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Paginação */}
      {totalPaginas > 1 && (
        <div style={{display:"flex",gap:8,justifyContent:"center",marginTop:16}}>
          <button className="btn btn-ghost" disabled={pagina===1} onClick={()=>setPagina(p=>p-1)}>← Anterior</button>
          <span style={{padding:"8px 16px",fontSize:13,color:"#64748b"}}>
            Página {pagina} de {totalPaginas}
          </span>
          <button className="btn btn-ghost" disabled={pagina===totalPaginas} onClick={()=>setPagina(p=>p+1)}>Próxima →</button>
        </div>
      )}
    </div>
  )
}
